import React, { useState, useEffect } from "react";
import axios from "axios";
import {Card,CardContent,CardHeader,Typography,Button,Select,MenuItem,InputLabel,FormControl,TextField,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,} from "@mui/material";
import Swal from "sweetalert2";
import { BASE_URL } from "../../App";

const Bcs_Winding_Config = () => {
  const [branches, setBranches] = useState([]);
  const [stations, setStations] = useState([]);
  const [psgs, setPsgs] = useState([]);
  const [items, setItems] = useState([]);
  const [gridData, setGridData] = useState([]);
     const login_id=localStorage.getItem("LOGIN_ID");

  const [form, setForm] = useState({
    branch: "",
    station: "",
    psg: "",
    itemCode: "",
    windingRate: "",
    labourCharges: "",
    approvedCharge: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBranches();
    fetchPsgs();
  }, []);


  const fetchBranches = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/getBranchesforbcsconfig`);
      setBranches(res.data);
    } catch (err) {
      console.error("Error loading branches", err);
    }
  };

  
  const fetchStations = async (branch) => {
    try {
      const res = await axios.get(`${BASE_URL}/service-stations/${branch}`);
      setStations(res.data);
    } catch (err) {
      console.error("Error loading stations", err);
    }
  };


  const fetchPsgs = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/psg`);
      setPsgs(res.data);
    } catch (err) {
      console.error("Error loading PSGs", err);
    }
  };


  const fetchItems = async (psg) => {
    try {
      const res = await axios.get(`${BASE_URL}/items/${psg}`);
      setItems(res.data);
    } catch (err) {
      console.error("Error loading items", err);
    }
  };


  const fetchGridData = async (branch) => {
    if (!branch) return;
    try {
      const res = await axios.get(`${BASE_URL}/windingwire/${branch}`);
      setGridData(res.data);
    } catch (err) {
      console.error("Error loading grid data", err);
    }
  };


  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
    if (field === "branch") {
      fetchStations(value);
      fetchGridData(value);
    }
    if (field === "psg") fetchItems(value);
  };


  const handleSubmit = async () => {
  setLoading(true);
  try {
    await axios.post(`${BASE_URL}/windingwire`, {
      branch: form.branch,
      service_station: form.station,
      service_station_name:
        stations.find((s) => s.code === form.station)?.name || "",
      psg: form.psg,
      item: form.itemCode,
      winding_rate: form.windingRate,
      labour_charge: form.labourCharges,
      LOGIN_ID: login_id,
    });

    Swal.fire({
      icon: "success",
      title: "Saved Successfully",
      text: "Winding wire rate updated successfully!",
      confirmButtonColor: "#1976d2"
    });

    fetchGridData(form.branch);
    setForm({
      branch: "",
      station: "",
      psg: "",
      itemCode: "",
      windingRate: "",
      labourCharges: "",
      approvedCharge: "",
    });
  } catch (err) {
    console.error("Error saving config", err);

    
    Swal.fire({
      icon: "error",
      title: "Save Failed",
      text: "Something went wrong while saving!",
      confirmButtonColor: "#d33"
    });
  }
  setLoading(false);
};



const handleEdit = async (row) => {
  setForm({
    branch: row.Branch,
    station: row.ServiceCentreCode,
    psg: row.PSG,
    itemCode: "", 
    windingRate: row.WireRate,
    labourCharges: row.LabourCharge,
    approvedCharge: row.ApprovedRate || "",
  });

 
  await fetchItems(row.PSG);

  setForm((prev) => ({
    ...prev,
    itemCode: row.Itemcode,
  }));
};


  return (
    <div className="container mx-auto py-6">
      <Card sx={{ boxShadow: 4, borderRadius: 3 }}>
        <CardHeader
          title={
            <Typography
              variant="h6"
              align="center"
              sx={{ bgcolor: "#3a5977ff", color: "white", p: 1, borderRadius: 2 }}
            >
              BCS SERVICECLAIM WINDING WIRERATE CONFIGURATION
            </Typography>
          }
        />
        <CardContent>
    
          <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
            <FormControl fullWidth>
              <InputLabel>Branch</InputLabel>
              <Select
                value={form.branch}
                onChange={(e) => handleChange("branch", e.target.value)}
                label="Branch"
              >
                {branches.map((b) => (
                  <MenuItem key={b.code} value={b.code}>
                    {b.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Service Station</InputLabel>
              <Select
                value={form.station}
                onChange={(e) => handleChange("station", e.target.value)}
                label="Service Station"
              >
                {stations.map((s) => (
                  <MenuItem key={s.code} value={s.code}>
                    {s.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

        
          <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
            <FormControl fullWidth>
              <InputLabel>PSG</InputLabel>
              <Select
                value={form.psg}
                onChange={(e) => handleChange("psg", e.target.value)}
                label="PSG"
              >
                {psgs.map((p) => (
                  <MenuItem key={p.code} value={p.code}>
                    {p.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Item Code</InputLabel>
              <Select
                value={form.itemCode}
                onChange={(e) => handleChange("itemCode", e.target.value)}
                label="Item Code"
              >
                {items.map((i) => (
                  <MenuItem key={i.code} value={i.code}>
                    {i.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

        
          <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
            <TextField
              fullWidth
              label="Winding Rate"
              value={form.windingRate}
              onChange={(e) => handleChange("windingRate", e.target.value)}
            />
            <TextField
              fullWidth
              label="Labour Charges"
              value={form.labourCharges}
              onChange={(e) => handleChange("labourCharges", e.target.value)}
            />
          </div>

        
          <input
            type="hidden"
            value={form.approvedCharge}
            onChange={(e) => handleChange("approvedCharge", e.target.value)}
          />

        <div style={{ textAlign: "center", marginBottom: "16px" }}>
  <Button
    variant="contained"
    onClick={handleSubmit}
    disabled={loading}
    sx={{
      width: 150,
      backgroundColor: "#6de30dff",
      color: "#000",              
      "&:hover": {
        backgroundColor: "#27a427ff" 
      }
    }}
  >
    {loading ? "Saving..." : "Submit"}
  </Button>
</div>


          <TableContainer component={Paper}>
            <Table>
             <TableHead sx={{ bgcolor: "#138ab1a4" }}>
  <TableRow>
    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Branch</TableCell>
    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Station</TableCell>
    <TableCell sx={{ color: "white", fontWeight: "bold" }}>PSG</TableCell>
    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Item Code</TableCell>
    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Winding Rate</TableCell>
    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Labour Charges</TableCell>
    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Edit</TableCell>
  </TableRow>
</TableHead>

              <TableBody>
                {gridData.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.Branch}</TableCell>
                    <TableCell>{row.ServiceCentreName}</TableCell>
                    <TableCell>{row.PSG}</TableCell>
                    <TableCell>{row.Itemcode}</TableCell>
                    <TableCell>{row.WireRate}</TableCell>
                    <TableCell>{row.LabourCharge}</TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        onClick={() => handleEdit(row)}
                      >
                        Edit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </div>
  );
};

export default Bcs_Winding_Config;
